import React from 'react';
import { withRouter } from 'react-router-dom';
import Lang from '../../lang';
import $ from 'jquery'

// $(".mainSidemenu").hover(function(){
//     //console.log("dfvfdvtr");
//     $(".submenuleft").css("display","none");
//     $(this).find(".submenuleft").css("display","block");
// });
// $(".mainSidemenu").click(function(){
//     //console.log("fgytbytbty");
//     $(".submenuleft").css("display","none");
//     $(this).find(".submenuleft").css("display","block");
// });
// $(".sidebar_shift").mouseleave(function(){
//     $(this).find(".submenuleft").css("display","none");
// })



let nav_bar = window.localStorage.getItem('nav_bar')

class UnOrderedList extends React.Component {

    /**
     * Para alterar o url da página
     */
    handleRoute = (data) => {
        window.localStorage.setItem('nav_bar', data.url);
        this.props.history.push({
            pathname: data.url,
            state: {topBarMenu : this.props.submenus[data.submenu]}
        })
        if(data.url === '/dashboard'){
            this.props.refreshComponent();
        }
    }


    /**
     * Para a seleção ativa no painel esquerdo
     */
    getAffectiveUrl = () => {
        // let url = "";
        // if (this.props.linkdata) {
        //     if (this.props.linkdata.submenu) {
        //         let listarray = this.props.submenus[this.props.linkdata.submenu];
        //         listarray.map((list, index) => (
        //             url += "," + list.url
        //         ))
        //     } else {
        //         url = this.props.linkdata.url
        //     }
        // }
        // let selectedUrl = window.localStorage.getItem('nav_bar')
        // if(selectedUrl === '/conta_regras_form/nivel-2' || selectedUrl === '/conta_regras_form/nivel-1' || selectedUrl === '/conta_operações'){
        //     return "/conta_corrente"
        // }else{
            return this.props.linkdata.url;
        // }
    }


    /**
     * Crie o menu esquerdo da página
     */
    createSelectedLi = () => {

        let url = this.getAffectiveUrl()
        this.props.linkdata['url'] = url
        let navBarSelected =  window.localStorage.getItem('nav_bar')
        if(navBarSelected === '/conta_regras_form/gestaoRegras' || navBarSelected === '/conta_regras_form/nivel-1' || navBarSelected === '/conta_opera%C3%A7%C3%B5es'){
            navBarSelected = "/conta_corrente"
        }else if(navBarSelected === '/minhas_avalia%C3%A7%C3%B5es' || navBarSelected === '/rutulo_processos'){
            navBarSelected = '/rotulos'
        }

        if (this.props.linkdata && this.props.linkdata.url) {
            return (
                <li className={`${url.includes(navBarSelected) ? "active" : ''} d-flex justify-content-center align-items-center`} onMouseEnter={() => this.props.mouseHover(this.props.index)}>
                    {
                        // this.props.linkdata.submenu ?
                        //     <a data-toggle="tab dd">
                        //         <span>
                        //             <span className={`sivdp-icon sivdp-${this.props.linkdata.type}`}></span>
                        //         </span>
                        //         <span className="title">{this.props.name}</span>
                        //         {
                        //             this.createSubMenu(this.props.submenus[this.props.linkdata.submenu])
                        //         }
                        //     </a>
                        //     :
                            <a data-toggle="tab" onClick={() => this.handleRoute(this.props.linkdata)}>
                                <span>
                                    {/* {
                                        this.props.linkdata.name === "Instalações Vínicas" ? 
                                        <span>
                                          <img className='img-normal' src='/imgs/instalacoesvinicas.svg' alt="" /> 
                                          <img className='img-hover' src='/imgs/instalacoesvinicas-red.svg' alt="" />
                                        </span>
                                        : */}
                                        <span className={`sivdp-icon sivdp-${this.props.linkdata.type}`}></span>
                                    {/* } */}
                                </span>
                                <span className="title">{this.props.name}</span>
                            </a>
                    }
                </li>
            )
        } else {
            return (
                <li className={`${navBarSelected === url ? "active" : ''} d-flex justify-content-center align-items-center`} onMouseEnter={() => this.props.mouseHover(this.props.index)}>
                    
                    {
                        // this.props.linkdata.submenu ?
                        //     <a data-toggle="tab">
                        //         <span>
                        //             <span className={`sivdp-icon sivdp-${this.props.linkdata.type}`}></span>
                        //         </span>
                        //         <span className="title">{this.props.name}</span>
                        //         {
                        //             this.createSubMenu(this.props.submenus[this.props.linkdata.submenu])
                        //         }
                        //     </a>
                        //     :
                            <a data-toggle="tab" onClick={() => this.handleRoute(this.props.linkdata)}>
                                <span>
                                    {/* {
                                        this.props.linkdata.name === "Instalações Vínicas" ? 
                                        <img src='/imgs/instalacoesvinicas.svg' alt="" />
                                        : */}
                                        <span className={`sivdp-icon sivdp-${this.props.linkdata.type}`}></span>
                                    {/* } */}
                                </span>
                                <span className="title">{this.props.name}</span>
                            </a>
                    }
                   
                </li>
            )
        }
    }

    /**
    * Criar submenu esquerdo da página
    */
    createSubMenu = (list) => {
        return (
            <ul className={this.props.subMenuDisplay[this.props.index] ? "list-unstyled sub-menu subMenudisplay" : "list-unstyled sub-menu"}>
                {/* <span className="closeSubmenu"><i className="fas fa-times"></i></span>  */
                }
                {
                    list.map((_li, index) => (
                        <li key={index} className={window.localStorage.getItem('nav_bar') == _li.url ? "active" : ''} onClick={() => this.handleRoute(_li)} >
                            <span className="leftsubmenu">
                                <span>
                                    <span className={`sivdp-icon sub-icon sivdp-${_li.type}`}></span>
                                </span>
                                <span className="title1">{Lang.langCheck.langRequest(`${_li.name}`)}</span>
                            </span>
                        </li>
                    ))
                }
            </ul>
        )
    }

    /*  Para renderizar o conteúdo html da página   */
    render() {
        return (
            this.createSelectedLi()
        )
    }
}

export default withRouter(UnOrderedList);